import React from 'react';
import { Link } from 'react-router-dom';
import { Home, ArrowRight } from 'lucide-react';
import SEO from '../components/SEO';

export default function NotFoundPage() {
  return (
    <>
      <SEO title="Page Not Found" description="The page you are looking for could not be found." path="/404" noindex />
    <section className="relative min-h-[80vh] flex items-center pt-32 pb-20 bg-gradient-to-br from-[#0a1b35] via-[#0d2143] to-[#15315c] overflow-hidden">
      <div className="absolute inset-0 bg-grid opacity-25" />
      <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full" style={{ background: 'radial-gradient(circle, rgba(232,184,99,0.13) 0%, transparent 65%)' }} />

      <div className="relative max-w-[800px] mx-auto px-5 sm:px-6 lg:px-10 text-center">
        <p className="font-serif text-[120px] sm:text-[160px] leading-none gold-gradient font-medium">404</p>
        <h1 className="mt-4 font-serif text-white font-medium text-[28px] sm:text-[36px] lg:text-[44px] leading-tight tracking-tight">
          That page wandered off the engagement plan.
        </h1>
        <p className="mt-5 text-white/75 text-[15.5px] sm:text-[17px] leading-relaxed">
          The page you are looking for could not be found. It may have been moved,
          renamed, or is temporarily unavailable.
        </p>
        <div className="mt-9 flex flex-wrap items-center justify-center gap-3">
          <Link to="/" className="inline-flex items-center gap-2.5 px-7 py-4 rounded-full bg-gradient-to-r from-[#d49d3f] to-[#b8842a] hover:from-[#e8b863] hover:to-[#d49d3f] text-[#0a1b35] font-semibold text-[14px] tracking-wide transition-all duration-300 shadow-xl shadow-[#d49d3f]/25 hover:-translate-y-0.5">
            <Home className="w-4 h-4" />
            Back to Home
          </Link>
          <Link to="/contact" className="inline-flex items-center gap-2 px-7 py-4 rounded-full border border-white/22 hover:border-[#e8b863]/55 text-white text-[14px] font-medium tracking-wide hover:bg-white/5 transition-all duration-300">
            Contact us
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
    </>
  );
}
